<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import axios from '@axios';
import { required, email } from '@validations';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        tipopedidoid: '',
        estabelecimentoid: '',
        tipopedidoestabnatopestadual: '',
        tipopedidoestabnatopinterest: '',
        tipopedidoestabnatopestrang: '',
        tipopedidoestabnatopncestadual: '',
        tipopedidoestabnatopncinterest: '',
        tipopedidoestabnatopzf: '',
        tipopedidoestabnatopimportado: '',
        tipopedidoestabnatopcfestadual: '',
        tipopedidoestabnatopcfinterest: '',
        tipopedidoestabnatoprvestadual: '',
        tipopedidoestabnatoprvinterest: '',
        tipopedidoestabnatopareaolivrecom: '',
        isDefault: false,
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  data() {
    return {
      dataFromApi: null,
      dataFromApiTipoPedido: null,
      dataFromApiEstabelecimento: null,
    };
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isFormValid() {
      return (
        this.dataForm.tipopedidoid
        && this.dataForm.estabelecimentoid
        && this.dataForm.tipopedidoestabnatopestadual
        && this.dataForm.tipopedidoestabnatopinterest
        && this.dataForm.tipopedidoestabnatopestrang
        && this.dataForm.tipopedidoestabnatopncestadual
        && this.dataForm.tipopedidoestabnatopncinterest
        && this.dataForm.tipopedidoestabnatopzf
        && this.dataForm.tipopedidoestabnatopimportado
        && this.dataForm.tipopedidoestabnatopcfestadual
        && this.dataForm.tipopedidoestabnatopcfinterest
        && this.dataForm.tipopedidoestabnatoprvestadual
        && this.dataForm.tipopedidoestabnatoprvinterest
        && this.dataForm.tipopedidoestabnatopareaolivrecom
      );
    },
  },
  methods: {
    async validateForm() {
      this.$emit('ok', this.dataForm);
      this.$bvModal.hide(this.idModal);
    },
    async fetchDataFromNaturezaOperacao() {
      try {
        const response = await axios.get('/natureza-operacao');
        this.dataFromApi = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromTipoPedido() {
      try {
        const response = await axios.get('/tipo-pedido');
        this.dataFromApiTipoPedido = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromEstabelecimento() {
      try {
        const response = await axios.get('/estabelecimento');
        this.dataFromApiEstabelecimento = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    onModalShow() {
      this.fetchDataFromNaturezaOperacao();
      this.fetchDataFromTipoPedido();
      this.fetchDataFromEstabelecimento();
    },
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === this.idModal) {
        this.onModalShow();
      }
    });
  },
  beforeDestroy() {
    this.$root.$off('bv::modal::show');
  },
};
</script>

<template>
  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      :id="idModal"
      :title="titleModal"
      :ok-disabled="dataForm.isDefault || !isFormValid"
      :ok-title="labelBtnOk"
      ok-variant="success"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      @ok="validateForm"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
  >
    <validation-observer ref="refFormData" v-slot="{ validate }">
      <b-tabs content-class="mt-2" justified>
        <b-tab active title="Estabelecimento">
          <b-form @submit.prevent>
            <b-row>
              <b-col
                  cols="6"
                  class="mb-0"
              >
                <b-form-group
                    label="Tipo Pedido"
                    label-for="tipopedidoid"
                >
                  <validation-provider
                      v-slot="{ errors }"
                      name="Tipo Pedido"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoid"
                        id="tipopedidoid"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApiTipoPedido"
                        value-field="tipopedidoid"
                        text-field="tipopedidodescricao"
                        placeholder="Selecione um Tipo Pedido"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Estabelecimento"
                    label-for="estabelecimentoid"
                >
                  <validation-provider
                      v-slot="{ errors }"
                      name="Estabelecimento"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.estabelecimentoid"
                        id="estabelecimentoid"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApiEstabelecimento"
                        value-field="estabelecimentoid"
                        text-field="estabelecimentorazaosocial"
                        placeholder="Selecione um estabelecimento"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Estadual (Indústria)"
                    label-for="tipopedidoestabnatopestadual"
                >
                  <validation-provider
                      v-slot="{ errors }"
                      name="Nat Oper Estadual (Indústria)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopestadual"
                        id="tipopedidoestabnatopestadual"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Nat Oper Estadual (Indústria)"
                        :disabled="dataForm.isDefault"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Interestadual (Indústria)"
                    label-for="tipopedidoestabnatopinterest"
                >
                  <validation-provider
                      v-slot="{ errors }"
                      name="Nat Oper Interestadual (Indústria)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopinterest"
                        id="tipopedidoestabnatopinterest"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Nat Oper Interestadual (Indústria)"
                        :disabled="dataForm.isDefault"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Estadual (Revenda)"
                    label-for="tipopedidoestabnatopestrang"
                >
                  <validation-provider
                      v-slot="{ errors }"
                      name="Nat Oper Estadual (Revenda)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopestrang"
                        id="tipopedidoestabnatopestrang"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Nat Oper Estadual (Revenda)"
                        :disabled="dataForm.isDefault"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Interestadual (Revenda)"
                    label-for="tipopedidoestabnatopncestadual"
                >
                  <validation-provider
                      v-slot="{ errors }"
                      name="Nat Oper Interestadual (Revenda)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopncestadual"
                        id="tipopedidoestabnatopncestadual"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Nat Oper Interestadual (Revenda)"
                        :disabled="dataForm.isDefault"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Estadual (Cons.Final/Rural)"
                    label-for="tipopedidoestabnatopncinterest"
                >
                  <validation-provider
                      v-slot="{ errors }"
                      name="Nat Oper Estadual (Cons.Final/Rural)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopncinterest"
                        id="tipopedidoestabnatopncinterest"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Nat Oper Estadual (Cons.Final/Rural)"
                        :disabled="dataForm.isDefault"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Interestadual (Cons.Final/Rural)"
                    label-for="tipopedidoestabnatopzf"
                >
                  <validation-provider
                      v-slot="{ errors }"
                      name="Nat Oper Interestadual (Cons.Final/Rural)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopzf"
                        id="tipopedidoestabnatopzf"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Nat Oper Interestadual (Cons.Final/Rural)"
                        :disabled="dataForm.isDefault"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Estadual (Não Contribuinte)"
                    label-for="tipopedidoestabnatopimportado"
                >
                  <validation-provider
                      v-slot="{ errors }"
                      name="Nat Oper Estadual (Não Contribuinte)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopimportado"
                        id="tipopedidoestabnatopimportado"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Nat Oper Estadual (Não Contribuinte)"
                        :disabled="dataForm.isDefault"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper Interestadual (Não Contribuinte)"
                    label-for="tipopedidoestabnatopcfestadual"
                >
                  <validation-provider
                      v-slot="{ errors }"
                      name="Nat Oper Interestadual (Não Contribuinte)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopcfestadual"
                        id="tipopedidoestabnatopcfestadual"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Nat Oper Interestadual (Não Contribuinte)"
                        :disabled="dataForm.isDefault"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper (Estrangeira)"
                    label-for="tipopedidoestabnatopcfinterest"
                >
                  <validation-provider
                      v-slot="{ errors }"
                      name="Nat Oper (Estrangeira)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopcfinterest"
                        id="tipopedidoestabnatopcfinterest"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Nat Oper (Estrangeira)"
                        :disabled="dataForm.isDefault"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper (Zona Franca)"
                    label-for="tipopedidoestabnatoprvestadual"
                >
                  <validation-provider
                      v-slot="{ errors }"
                      name="Nat Oper (Zona Franca)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatoprvestadual"
                        id="tipopedidoestabnatoprvestadual"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Nat Oper (Zona Franca)"
                        :disabled="dataForm.isDefault"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper (Área Livre Comércio)"
                    label-for="tipopedidoestabnatoprvinterest"
                >
                  <validation-provider
                      v-slot="{ errors }"
                      name="Nat Oper (Área Livre Comércio)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatoprvinterest"
                        id="tipopedidoestabnatoprvinterest"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Nat Oper (Área Livre Comércio)"
                        :disabled="dataForm.isDefault"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                  cols="6"
                  class="mb-1"
              >
                <b-form-group
                    label="Nat Oper (Produto Importado)"
                    label-for="tipopedidoestabnatopareaolivrecom"
                >
                  <validation-provider
                      v-slot="{ errors }"
                      name="Nat Oper (Produto Importado)"
                      rules="required"
                  >
                    <b-form-select
                        v-model="dataForm.tipopedidoestabnatopareaolivrecom"
                        id="tipopedidoestabnatopareaolivrecom"
                        :state="errors.length > 0 ? false : null"
                        :options="dataFromApi"
                        value-field="naturezaoperacaoid"
                        text-field="naturezaoperacaodescricao"
                        placeholder="Nat Oper (Produto Importado)"
                        :disabled="dataForm.isDefault"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
      </b-tabs>

    </validation-observer>
  </b-modal>
</template>
